import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientGraphQLAuthMutation } from "../../../../core/data/GraphQLApi";
import { clientPOST } from "../../../../core/data/RestApi";
import { endpoints } from "../../../../core/defaultValues";
import { resetALL } from "../../../../.globals/redux/actions";
import { ExceptionManager } from "../../../../core/logManager";
import { isJson } from "../../../../core/data/Helpers";
//actions
import { logout, loginConfirmResult, login, updateTermsAndCondition } from "Redux/actions";
import { setCookie, eraseCookie } from "Core/views/login/helper";

const INIT_STATE = {
  loading: false,
  showConfirm: false,
  error: null,
  result: false,
  hasPermissionToMigrateUser: false
};

const route = "core/views/confirmUser/redux/slice";

export const verifyUserRequest = createAsyncThunk("confirmUser/verifyUser",
  async (payload, { dispatch, rejectWithValue }) => {

    const { username, code, password, navigate, authId } = payload
    try {
      const query = `
       mutation ( $code: String!, $password: String!, $username: String!){
            result: verifyUser (
                username: $username
                code: $code
                password: $password
            ) {
                success
                message
            }
        }
      `;

      const data = await clientGraphQLAuthMutation(
        query,
        {
          username,
          code,
          password
        }
      );

      if (data?.result?.success) {
        //remove local preferences
        localStorage.removeItem("preferencesUser")
        localStorage.removeItem("preferencesCompany")
        localStorage.removeItem("preferencesOther")

        dispatch(login({ username: username.trim(), password: password.trim(), navigate, authId }));
        dispatch(updateTermsAndCondition({ username: username.trim(), password: password.trim(), authId }));
        return null
      }

      return data?.result?.message

    } catch (exc) {
      // catch throw
      ExceptionManager(exc, route, "verifyUserRequest");
      return rejectWithValue(exc);
    }
  }
);

export const codeVerificationRequest = createAsyncThunk("confirmUser/codeVerification",
  async (payload, { dispatch, rejectWithValue }) => {

    const { username, code, navigate, isResetPassword, authId } = payload
    try {
      const query = `
        query ($code: String!, $username: String!, $type: enumCodeType, $authId: String){
            result: validateCode(
                code: $code
                username: $username
                type: $type
                authId: $authId
            ) {
                registrationStatus
                isValid
            }
        }
      `;

      const data = await clientGraphQLAuthMutation(
        query,
        {
          username: username,
          code: code.toString(),
          type: isResetPassword ? "forgotPassword" : "verifyEmail",
          authId
        }
      );

      if (isResetPassword) {
        if (data?.result?.isValid) {
          return
        } else {
          navigate("/")
          dispatch(loginConfirmResult("confirmUser_codeNotValid"))
        }
      } else {

        if (!data?.result?.isValid) {
          dispatch(loginConfirmResult("confirmUser_userCodeExpired"));
          navigate("/")
          dispatch(logout());
        }

        if (data?.result.registrationStatus == "Active") {
          return {
            isValid: true,
            message: "confirmUser_userIsActive"
          };
        }
      }


    } catch (exc) {
      // catch throw
      ExceptionManager(exc, route, "codeVerificationRequest");
      return rejectWithValue(exc);
    }
  }
);

export const forgotPasswordConfirmRequest = createAsyncThunk('confirmUser/forgotPasswordConfirm',
  async ({ username, confirmationCode, password, confirmPassword }, { rejectWithValue }) => {
    try {

      if (password !== confirmPassword) {
        return rejectWithValue('forgotPassword_passwordError');
      }

      const data = await clientGraphQLAuthMutation(`
                mutation ($confirmationCode: String!, $username: String!, $password: String!  ) {
                    result: confirmForgotPassword (
                        confirmationCode: $confirmationCode
                        username: $username
                        password: $password
                    )
        }
            `,
        {
          username, confirmationCode, password, confirmPassword
        }
      )

      return { isValid: data.result }
    } catch (exc) {
      ExceptionManager(exc, route, "forgotPasswordRequest");
      return rejectWithValue(exc.toString());
    }
  });

const confirmUserRedux = createSlice({
  name: "confirmUser",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload ? { ...state, ...action.payload } : INIT_STATE
    },
    setError(state, action) {
      state.error = action.payload;
    }

  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    // verifyUserRequest
    builder.addCase(verifyUserRequest.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(verifyUserRequest.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action.payload;;
    });
    builder.addCase(verifyUserRequest.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // verifyUserRequest
    builder.addCase(codeVerificationRequest.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(codeVerificationRequest.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action.payload;
    });
    builder.addCase(codeVerificationRequest.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(forgotPasswordConfirmRequest.pending, (state) => {
      state.loading = true
      state.error = null
    });
    builder.addCase(forgotPasswordConfirmRequest.fulfilled, (state, action) => {
      return { ...state, loading: false, result: action.payload }
    });
    builder.addCase(forgotPasswordConfirmRequest.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

  }
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = confirmUserRedux;

// Extract and export each action creator by name
export const {
  reset,
  setError
} = actions;

// Export the reducer, either as a default or named export
export default reducer;
